import React, { useState } from 'react';
import './Email.css';

function EmailPL() {
  const [status, setStatus] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setStatus('');

    try {
      const response = await fetch('https://formspree.io/f/YOUR_FORM_ID', {
        method: 'POST',
        body: new FormData(e.target),
        headers: {
          Accept: 'application/json',
        },
      });

      if (response.ok) {
        setStatus('success');
        e.target.reset();
      } else {
        setStatus('error');
      }
    } catch (error) {
      setStatus('error');
    }

    setIsSubmitting(false);
  };

  return (
    <div className="email-container">
      <header className="email-header">
        <h1 className="email-title">Skontaktuj się ze mną</h1>
        <p className="email-subtitle">
          Zapraszam do kontaktu w sprawie współpracy, pytań lub po prostu, aby się przywitać!
          Odpowiem najszybciej jak to możliwe.
        </p>
      </header>

      {status === 'success' && (
        <div className="form-message success">
          Dziękuję za wiadomość! Skontaktuję się z Tobą wkrótce.
        </div>
      )}

      {status === 'error' && (
        <div className="form-message error">
          Ups! Wystąpił problem z wysłaniem wiadomości. Spróbuj ponownie lub napisz bezpośrednio na joanna.k.slawinska@gmail.com
        </div>
      )}

      <form className="contact-form" onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="name">Imię</label>
          <input
            type="text"
            id="name"
            name="name"
            required
            placeholder="Twoje imię"
          />
        </div>

        <div className="form-group">
          <label htmlFor="email">Email</label>
          <input
            type="email"
            id="email"
            name="email"
            required
            placeholder="twoj.email@example.com"
          />
        </div>

        <div className="form-group">
          <label htmlFor="subject">Temat</label>
          <input
            type="text"
            id="subject"
            name="subject"
            required
            placeholder="Czego dotyczy wiadomość?"
          />
        </div>

        <div className="form-group">
          <label htmlFor="message">Wiadomość</label>
          <textarea
            id="message"
            name="message"
            required
            placeholder="Twoja wiadomość..."
          />
        </div>

        <button
          type="submit"
          className="submit-button"
          disabled={isSubmitting}
        >
          {isSubmitting ? 'Wysyłanie...' : 'Wyślij wiadomość'}
        </button>
      </form>

      <div style={{ marginTop: '2rem', color: '#666', fontSize: '0.9rem' }}>
        <p>Możesz też napisać bezpośrednio:</p>
        <p>Email: <a href="mailto:joanna.k.slawinska@gmail.com" style={{ color: '#0074f0' }}>joanna.k.slawinska@gmail.com</a></p>
        <p>Telefon: +48 792 906 215</p>
      </div>
    </div>
  );
}

export default EmailPL; 